var parent = require('../../actual/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/array/from.js
// module id = 553
// module chunks = 0 1